// extracted by mini-css-extract-plugin
export var blue = "cT_dB";
export var large = "cT_bZ";
export var medium = "cT_b0";
export var white = "cT_hS";